import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  theoryQuestion: Record<string, any> = {};
  wrongAnswer: Record<string, any> = {};
}
